import { render, staticRenderFns } from "./booking-workplace.vue?vue&type=template&id=79038af4&"
import script from "./booking-workplace.vue?vue&type=script&lang=js&"
export * from "./booking-workplace.vue?vue&type=script&lang=js&"
import style0 from "./booking-workplace.vue?vue&type=style&index=0&id=79038af4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports